import React, { useCallback, useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useStores } from "../../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import LogoImg from "../../assets/icons/timetrap-logo.svg";
import { BrandContainer, Container, BrandIcon, Card } from "../Login/styled";
import { Text } from "@chakra-ui/layout";
import { ChangePasswordForm } from "../../components/ChangePasswordForm";
import { useEffect } from "react";
import { useToast } from "@chakra-ui/react";

export const ChangePassword: React.FC = observer(() => {
  const { session } = useStores();
  const { t } = useTranslation();
  const toast = useToast();
  const location = useLocation();
  // const history = useHistory();


  const [email, setEmail] = useState<string | null>("");
  const [token, setToken] = useState<string | null>("");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    setEmail(searchParams.get("email"));
    setToken(searchParams.get("token"));
  }, [location]);

  const handleSubmit = useCallback(
    async (email: string, password: string) => {
      try {
        if (!token) {
          throw new Error("Missing token");
        }

        await session.changePassword(email, password, token);

        toast({
          title: t("common.actionExecutedSuccessfully"),
          status: "success",
          position: "bottom-left",
        });
        return <Navigate to={"/"} />;
        // const searchParams = new URLSearchParams(location.search);
        // searchParams.delete("email");
        // searchParams.delete("token");
        // history.replace({
        //   pathname: location.pathname,
        //   search: searchParams.toString(),
        // });
      } catch (err) {
        console.log(err);
        toast({
          title: t("common.error"),
          status: "error",
          position: "bottom-left",
        });
      }
    },
    [token, session, toast, t]
  );

  if (session.isLogged) {
    return <Navigate to={"/"} />;
  }

  return (
    <Container>
      <BrandContainer>
        <BrandIcon>
          <img src={LogoImg} alt={"TimeTrap"} />
        </BrandIcon>
      </BrandContainer>
      <Card>
        <Text fontSize={"3xl"} fontWeight={600}>
          {t<string>("screens.lostPassword.title")}
        </Text>

        <ChangePasswordForm
          email={email}
          onSubmit={handleSubmit}
          isLoading={session.isSubmitting}
        />

        <Text style={{ marginTop: "2rem" }}>
          <Link color="teal.500" to={"/login"}>
            {t<string>("common.backToLogin")}
          </Link>
        </Text>
      </Card>
    </Container>
  );
});
